import { useEffect, useState } from 'react';
import HbsArchive from './HbsArchive';
import HbsDetail from './HbsDetail';
import { Routes, Route } from 'react-router-dom';

function App() {
	const [bulletinData, setBulletinData] = useState(null);

	useEffect(() => {
		const fetchBulletin = async () => {
			try {
				const response = await fetch(`/details.json`, {
					// headers: {
					// 	'Content-Type': 'application/json',
					// 	Accept: 'application/json',
					// },
				});
				if (!response.ok) throw new Error('Network response was not ok');

				setBulletinData(await response.json());
			} catch (err) {
				console.error('Fetching error:', err);
			}
		};

		fetchBulletin();
	}, []);

	return (
		<div>
			<Routes>
				<Route path={'/'} element={<HbsArchive bulletinData={bulletinData} />} />
				<Route
					path={'/detail/:index'}
					element={<HbsDetail bulletinData={bulletinData} />}
				/>
			</Routes>
		</div>
	);
}

export default App;
